import { getOfferProduct, sendAnalytics } from 'shared/utils/analytics';

interface ITrackPhoneClickParams {
  offerId: number;
  position: number;
  label: string;
  houseId: number;
}

export const trackPhoneShow = ({ offerId, position, label, houseId }: ITrackPhoneClickParams) =>
  sendAnalytics({
    category: 'Phones',
    label,
    action: 'Open_house_offers',
    products: [getOfferProduct(offerId, position)],
    page: {
      extra: { houseId },
    },
  });
